import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e72974e4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "mt-4 mb-3 border-2 rounded bg-white dark:bg-dark-500 dark:border-dark-400" }
const _hoisted_3 = { class: "text-2xl font-bold border pl-3 py-2 flex bg-primary-500 text-white dark:bg-dark-400 dark:border-dark-400 dark:text-dark-text" }
const _hoisted_4 = { class: "mt-1" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex-grow" }, null, -1))
const _hoisted_6 = { class: "p-3 pl-4" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "flex items-center" }
const _hoisted_9 = { class: "border rounded px-1 text-arena border-arena dark:text-arena-dark dark:border-arena-dark" }
const _hoisted_10 = { class: "ml-3 text-xl text-gray-800 dark:text-dark-text" }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { class: "mt-4 mb-3 border-2 rounded bg-white dark:bg-dark-500 dark:border-dark-400" }
const _hoisted_13 = { class: "text-2xl font-bold border pl-3 py-2 flex bg-primary-500 text-white dark:bg-dark-400 dark:border-dark-400 dark:text-dark-text" }
const _hoisted_14 = { class: "mt-1 mx-2" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex-grow" }, null, -1))
const _hoisted_16 = {
  key: 0,
  class: "flex justify-center items-center",
  style: {"height":"120px"}
}
const _hoisted_17 = { key: 1 }
const _hoisted_18 = ["onClick"]
const _hoisted_19 = { class: "text-xl flex items-center" }
const _hoisted_20 = { class: "material-icons mr-4" }
const _hoisted_21 = {
  key: 0,
  class: "text-arena"
}
const _hoisted_22 = {
  key: 1,
  class: "text-gray-500 dark:text-dark-text"
}
const _hoisted_23 = { class: "border rounded px-1 w-8 text-center text-arena border-arena dark:text-arena-dark dark:border-arena-dark" }
const _hoisted_24 = { class: "ml-3 text-gray-800 dark:text-dark-text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconTextButton = _resolveComponent("IconTextButton")!
  const _component_IconButton = _resolveComponent("IconButton")!
  const _component_LoadingPanel = _resolveComponent("LoadingPanel")!
  const _component_PrimaryModal = _resolveComponent("PrimaryModal")!

  return (_openBlock(), _createBlock(_component_PrimaryModal, {
    onClickBackground: _cache[3] || (_cache[3] = ($event: any) => (_ctx.close()))
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: _normalizeClass(["modal-size max-w-screen-lg box-border px-12 py-4 m-4 overflow-y-scroll select-none text-gray-800 dark:text-dark-text", {
        'custom-scrollbar': _ctx.isLightMode(),
        'custom-scrollbar-dark': !_ctx.isLightMode()
      }])
      }, [
        (_ctx.nested.selectedArenaId.value == '')
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("h2", _hoisted_4, _toDisplayString(_ctx.$t('message.arena')), 1),
                  _hoisted_5,
                  _createVNode(_component_IconTextButton, {
                    border_radius: 2,
                    class: "mx-2",
                    color_list: [
                'text-primary-500',
                'border-primary-500',
                'bg-white',
                'hover:border-primary-500',
                'hover:bg-gray-200',
                'active:border-primary-500',
                'active:bg-gray-300'
              ],
                    font_weight: '700',
                    icon: 'open_in_new',
                    iconSize: 'text-xl',
                    padding_bottom: 2,
                    padding_left: 12,
                    padding_right: 12,
                    padding_top: 2,
                    text: _ctx.$t('message.altPage'),
                    textSize: 'text-base',
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.clickAltanativeMainPage()))
                  }, null, 8, ["text"])
                ]),
                _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.$t('message.showEntryList')), 1)
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arenaPresenter.arenaUserEntryList.value, (entry, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  class: "cursor-pointer border rounded p-4 w-full hover:shadow-lg transition-shadow duration-200 mb-1 hover:border-arena text-gray-900 dark:border-dark-400 dark:text-dark-text dark:bg-dark-500 dark:hover:border-arena-dark",
                  onClick: ($event: any) => (_ctx.clickArena(entry))
                }, [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.formatDate(entry.entryDate)), 1),
                    _createElementVNode("div", _hoisted_10, _toDisplayString(entry.arenaId), 1)
                  ])
                ], 8, _hoisted_7))
              }), 128))
            ]))
          : (_ctx.arenaPresenter.arenaProblemElementList.value && _ctx.nested.selectedArenaId.value != '')
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, [
                    _createVNode(_component_IconButton, {
                      class: "mx-2",
                      color_list: ['bg-white', 'hover:bg-gray-200', 'active:bg-gray-300'],
                      icon: 'arrow_back',
                      iconColor: 'text-primary-500 dark:text-dark-text',
                      padding_left: 7,
                      padding_right: 7,
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.clickBack()))
                    }),
                    _createElementVNode("h2", _hoisted_14, _toDisplayString(_ctx.nested.selectedArenaId.value), 1),
                    _hoisted_15,
                    _createVNode(_component_IconTextButton, {
                      border_radius: 2,
                      class: "mx-2",
                      color_list: [
                'text-primary-500',
                'border-primary-500',
                'bg-white',
                'hover:border-primary-500',
                'hover:bg-gray-200',
                'active:border-primary-500',
                'active:bg-gray-300'
              ],
                      font_weight: '700',
                      icon: 'open_in_new',
                      iconSize: 'text-xl',
                      padding_bottom: 2,
                      padding_left: 12,
                      padding_right: 12,
                      padding_top: 2,
                      text: _ctx.$t('message.altPage'),
                      textSize: 'text-base',
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.clickAltanativeArenaPage()))
                    }, null, 8, ["text"])
                  ])
                ]),
                (_ctx.arenaPresenter.isLoading.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                      _createVNode(_component_LoadingPanel)
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_17, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arenaPresenter.arenaProblemElementList.value, (element, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: index,
                          class: "hover-hand border rounded p-4 w-full hover:shadow-lg transition-shadow duration-200 mb-1 hover:border-arena text-gray-900 dark:border-dark-400 dark:text-dark-text dark:bg-dark-500 dark:hover:border-arena-dark",
                          onClick: ($event: any) => (_ctx.arenaPresenter.setArenaProblem(element.problemId, element.arenaId, element.id, index))
                        }, [
                          _createElementVNode("div", _hoisted_19, [
                            _createElementVNode("span", _hoisted_20, [
                              (_ctx.arenaPresenter.arenaSolvedProblemList.value.has(element.id))
                                ? (_openBlock(), _createElementBlock("span", _hoisted_21, " check_circle "))
                                : (_openBlock(), _createElementBlock("span", _hoisted_22, " radio_button_unchecked "))
                            ]),
                            _createElementVNode("div", _hoisted_23, _toDisplayString(element.id), 1),
                            _createElementVNode("div", _hoisted_24, _toDisplayString(element.problemId), 1)
                          ])
                        ], 8, _hoisted_18))
                      }), 128))
                    ]))
              ]))
            : _createCommentVNode("", true)
      ], 2)
    ]),
    _: 1
  }))
}